export const myFilesText = {
  en: {
    sidebar: {
      brand: "ShadowVault",
      subtitle: "My Files",
      vault: "Vault",
      legacyContacts: "Legacy Contacts",
      checkIn: "Check-In",
    },
    vault: {
      planLimitWarning: "You've reached your plan limit.",
      upgradeButton: "Upgrade Plan",
      vaultSummary: "Vault Summary",
      categories: "Categories",
      categoriesSub: "Folders in your vault",
      files: "Files",
      filesSub: "Files securely stored",
      legacyContacts: "Legacy Contacts",
      legacyContactsSub: "People with vault access",
      myVault: "My Vault",
      clickCategoryHint: "Click a category to view its files.",
      noFilesYet: "No files yet. Add a folder to get started.",
      addFolder: "Add Folder",
      accessOverview: "Legacy Contact Access Overview",
      fullAccess: "✓ Full Access",
      partialAccess: "◑ Partial Access",
      continuityCheckIn: "Continuity Check-In",
      checkedInSuccessfully: "Checked-in Successfully!",
      nextCheckIn: "Your next check-in is in 90 days.",
      footerNote:
        "If you don't check in before your next deadline, your vault unlocks automatically — the legacy contacts you've chosen get access to the documents you've shared with them.",
    },
    folderCard: {
      file: "file",
      files: "files",
      full: "Full",
      partial: "Partial",
      nominee: "legacy contact",
      nominees: "legacy contacts",
    },
    alerts: {
      checkinSaved: (days) => `✓ Check-in interval saved: every ${days} days`,
      saveFailed: (msg) => `Failed to save: ${msg}`,
    },
  },
  zh: {
    sidebar: {
      brand: "ShadowVault",
      subtitle: "我的文件",
      vault: "保险库",
      legacyContacts: "法定联系人",
      checkIn: "签到",
    },
    vault: {
      planLimitWarning: "您已达到当前套餐的上限。",
      upgradeButton: "升级套餐",
      vaultSummary: "保险库概览",
      categories: "分类",
      categoriesSub: "保险库中的文件夹",
      files: "文件",
      filesSub: "已安全存储的文件",
      legacyContacts: "法定联系人",
      legacyContactsSub: "拥有保险库访问权限的人",
      myVault: "我的保险库",
      clickCategoryHint: "点击分类以查看其中的文件。",
      noFilesYet: "暂无文件,添加一个文件夹开始使用。",
      addFolder: "添加文件夹",
      accessOverview: "法定联系人访问权限概览",
      fullAccess: "✓ 完全访问",
      partialAccess: "◑ 部分访问",
      continuityCheckIn: "生命状态签到",
      checkedInSuccessfully: "签到成功!",
      nextCheckIn: "您的下次签到将在90天后。",
      footerNote:
        "如果您在下一次截止日期前未完成签到,您的保险库将自动解锁——您所选择的法定联系人将获得您与其共享的文件的访问权限。",
    },
    folderCard: {
      file: "个文件",
      files: "个文件",
      full: "完全",
      partial: "部分",
      nominee: "位法定联系人",
      nominees: "位法定联系人",
    },
    alerts: {
      checkinSaved: (days) => `✓ 签到周期已保存:每${days}天一次`,
      saveFailed: (msg) => `保存失败: ${msg}`,
    },
  },
};
